import contacts from 'src/i18n/en/fields/contacts';
import ambassadors from 'src/i18n/en/fields/ambassadors';
import invoices from 'src/i18n/en/fields/invoices';
import contact_groups from 'src/i18n/en/fields/contact_groups';
import payments from 'src/i18n/en/fields/payments';
import fundraising from 'src/i18n/en/fields/fundraising';
import event_transactions from 'src/i18n/en/fields/fundraising_transaction';
import events from 'src/i18n/en/fields/events';
import tax_receipts from 'src/i18n/en/fields/tax_receipts';
import payment_gateways from 'src/i18n/en/fields/payment_gateways';

const fields = {
  ambassadors,
  contacts,
  contact_groups,
  events,
  invoices,
  payments,
  fundraising,
  event_transactions,
  payment_gateways,
  tax_receipts,
};

export default fields;
